import type { ChatHistoryType } from '@/types/converse/chatHistory';
import { fetchWithRewrites } from '@/utils/fetchWithRewrites';
import { Box, Container, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CallsList from './CallsList';
import CallsSideSheet from './CallsSideSheet';
import CallStatus from './CallStatus';
import CallsChart from './CallsTriggered';
import MetricBox from './Metrix';

function CallsPage(): React.ReactNode {
  const [selectedCallId, setSelectedCallId] = useState<string | null>(null);
  const [transcript, setTranscript] = useState<ChatHistoryType['messages']>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [forceOpen, setForceOpen] = useState<boolean>(false);
  const [callConversations, setCallConversations] = useState<ChatHistoryType[]>(
    []
  );

  // Call statistics
  // const voicemail = callConversations.filter(
  //   (call) => call.status === 'voicemail'
  // ).length;
  // const others = callConversations.filter((call) => call.status === 'other').length;

  const getCalls = async () => {
    if (callConversations.length === 0) {
      const conversationsResponse = await fetchWithRewrites(
        `/api/v1/chat/history?sources=integrations.twilio.calls`
      );

      if (conversationsResponse.ok) {
        const conversationResponseJson = await conversationsResponse.json();

        const { chats } = conversationResponseJson;

        setCallConversations(chats);
      }

      setLoading(false);
    }
  };
  // // Handle transcript view
  const handleTranscriptClick = async (
    callId: string,
    openSideSheet?: boolean
  ) => {
    const requiredConversation = (callConversations ?? [])
      .filter((callConversation) => callConversation.id === callId)
      .pop() ?? { messages: [] };

    console.log('\n\n\nShowing Transcript for call Id : ', callId);
    console.log('\n\nRequired Conversation = ', requiredConversation);
    setSelectedCallId(callId);

    setForceOpen(!!openSideSheet);

    await getCalls();
    setTranscript(requiredConversation.messages);
    setLoading(true);

    // Simulate API call delay
    //   setTimeout(() => {
    //     setTranscript([callId] || []);
    //     setLoading(false);
    //   }, 800);
    // };
    await getCalls();
    setLoading(false);
  };

  useEffect(() => {
    getCalls();
  }, []);

  return (
    <CallsSideSheet
      loading={loading}
      panelWidth="30vw"
      selectedCallId={selectedCallId}
      transcript={transcript ?? []}
      forceOpen={forceOpen}
      defaultMaxWidth="xl"
      openMaxWidth="lg"
    >
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Typography sx={{ mb: 4 }} variant="h4">
          Calls Dashboard
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
              width: '60%',
            }}
          >
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: '1fr 1fr',
                  md: '1fr 1fr 1fr 1fr',
                },
                gap: 3,
                marginTop: '1rem',
              }}
            >
              <MetricBox
                color="primary"
                icon="💰"
                title="Account Balance"
                value="$1.00"
              />
              <MetricBox
                color="warning"
                icon="💸"
                title="Consumed Cost"
                value="$0.00"
              />
              <MetricBox
                color="success"
                icon="⏱️"
                title="Remaining Mins"
                value="5"
              />
              <MetricBox
                color="secondary"
                icon="⏸️"
                title="On Hold Balance"
                value="$0.00"
              />
            </Box>
            <CallsChart callsHistory={callConversations} />
          </Box>
          <Box sx={{ width: '40%' }}>
            <CallStatus
              callConnected={
                (callConversations ?? []).filter(
                  (call) => (call.messages ?? []).length > 0
                )?.length ?? 0
              } // Number of connected calls
              callFailed={
                (callConversations ?? []).filter(
                  (call) => (call.messages ?? []).length === 0
                ).length ?? 0
              } // Number of failed calls
              others={0} // Number of other calls
              totalCalls={(callConversations ?? []).length} // Total number of calls
              voicemail={0} // Number of voicemail calls
            />
          </Box>
        </Box>

        {/* Calls List */}
        <Box sx={{ marginTop: '1rem' }}>
          <CallsList
            calls={callConversations}
            loading={loading}
            onTranscriptClick={handleTranscriptClick}
          />
        </Box>
      </Container>
    </CallsSideSheet>
  );
}

export default CallsPage;
